import { useEffect } from 'react';
import { event as sendEvent } from '../insights';
export default function TrackImpression({ event, children }) {
    useEffect(() => {
        sendEvent(event);
    }, [event]);
    return children;
}
